import type { RecordObject } from "@/profitability/records/objects";
import { recordId } from "@/profitability/records/objects";
import { useCitations } from "@/profitability/sources/query";
import type { ReportRow } from "@/profitability/types";
import { type FigureGaps, figureGaps } from "./figure-gaps";
import { absentColumns } from "./missing-fields";

/**
 * Null when the run did not trace figures, so the sheet keeps the role-based
 * reading. `pending` while they load, so it does not say it the other way first.
 */
export const useRecordGaps = (
  businessId: string,
  runId: string | null | undefined,
  object: RecordObject,
  row: ReportRow,
): { gaps: FigureGaps | null; pending: boolean } => {
  const { dataset } = object;
  const wanted =
    !!runId &&
    !!dataset.traced?.length &&
    absentColumns(dataset, row).length > 0;
  const answer = useCitations(
    businessId,
    wanted ? runId : "",
    dataset.id,
    recordId(dataset, row),
    null,
  );
  const figures = answer.data?.figures;
  return {
    gaps:
      wanted && figures && Object.keys(figures).length
        ? figureGaps(dataset, row, figures)
        : null,
    pending: wanted && answer.isPending,
  };
};
